import React, { useEffect, useState, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import { useLocation, useHistory } from "react-router-dom";
import { Modal as bots } from "bootstrap";
import $ from "jquery";

import ico_add_img from "../../static/images/ico-add_img.svg";
import useOnceEffect from "../../Hooks/useOnceEffect";

function AddCurso({ data }) {
  const location = useLocation();
  const [type_courses, setType_courses] = useState([]);
  const [sectorList, setsectorList] = useState([]);
  const [levelCourses, setlevelCourses] = useState([]);
  const [modalidadCourses, setmodalidadCourses] = useState([]);
  const [languagesList, setlanguagesList] = useState([]);
  const [course, setcourse] = useState("");
  const [imgPortada, setimgPortada] = useState("");
  const [banner, setbanner] = useState("");
  const [showImgPortada, setshowImgPortada] = useState("");
  const [showBanner, setshowBanner] = useState("");

  const history = useHistory();

  useOnceEffect(() => {

    //Si esta en modo editar obtenemos informacion del curso
    if (location.state !== undefined) {
      axios
        .get("company-course/" + location.state.courseId)
        .then((result) => {
          setcourse(result.data);
          setimgPortada(result.data.coverImage);
          setbanner(result.data.image);
        });
    }

    axios.get("company-course/type-courses").then((result) => {
      setType_courses(result.data);
    });

    axios.get("access/sector-list").then((result) => {
      setsectorList(result.data);
    });

    axios.get("company-course/modalidad-courses").then((result) => {
      setmodalidadCourses(result.data);
    });

    axios.get("applicant-languages/list-language/").then((result) => {
      setlanguagesList(result.data);
    });

    axios.get("company-course/level-courses").then((result) => {
      setlevelCourses(result.data);
    });

  });

  function ActualizarCurso(values, resetForm, setSubmitting) {

    let curso = {
      ...values,
      idioma: values.id,
      modalidadId: values.modalidadCourseId,
      nivelId: values.nivelCourseId,
      tipoFormacionId: values.formationCourseId,
      idiomaId: values.id,
    };

    axios
      .post( "company-course/update", curso)
      .then(() => toast.success("Se ha actualizado la información del curso exitosamente"))
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  function addImage(result, formData) {

    let perfil = document.getElementById("profileImageUpdate");
    let  { data: {companyCourseId} } = result

    axios
    .post( `company-course/photo/${companyCourseId}`,formData)
    .then(() => {

      toast.success("Se ha actualizado la información del curso exitosamente", {duration: 300})
      perfil.value = "";
    })

    .catch((e) => {
      throw e
    });
  }

  async function postCurso(values, resetForm, setSubmitting) {
    
    let curso = {
      ...values,
      companyId: data.companyProfileId ?? 0,
      courseId: 0,
      idiomaId: values.id,
      modalidadId: values.modalidadCourseId,
      nivelId: values.nivelCourseId,
      tipoFormacionId: values.formationCourseId,
    };

    try {
      
      let result = await axios.post("company-course/create", curso)

      let formData = new FormData();
      formData.append("courseBanner", imgPortada);
      formData.append("cursoImage", banner);
      addImage(result, formData)

      resetForm(true);
    } catch (error) {
      if (error?.response?.status === 403) {
        toast.error("Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador")
        history.push("/")
      }
      if (error?.response?.status === 400) {
        toast.error(error.response.data.message);
      }
    } finally {
      setSubmitting(false)
    }
  }

  function ActualizarPortada() {
    let portada = document.getElementById("bannerImageUpdate");

    if(course?.companyCourseId) {
      let file = portada.files[0]

      let data = new FormData();
      data.append("courseBanner", file)
      addImage({
        data: {
          companyCourseId:  course?.companyCourseId
        }
      }, data);
      
    }

    if (portada.files[0] !== undefined) {
      setimgPortada(portada.files[0]);
      setshowImgPortada(URL.createObjectURL(portada.files[0]));
      portada.value = "";
      $("#actualizar-portada-modal").modal("hide");
    } else {
      toast.error("Elija una imagen");
    }
  }

  const ActualizarPerfil = () => {

    let perfil = document.getElementById("profileImageUpdate");

    if(course?.companyCourseId) {
      let file = perfil.files[0]

      let data = new FormData();
      data.append("cursoImage", file)
      addImage({data: {
        companyCourseId:  course?.companyCourseId
      }}, data);
      
    }

    
    if (perfil.files[0] !== undefined) {
      setbanner(perfil.files[0]);
      setshowBanner(URL.createObjectURL(perfil.files[0]));
      perfil.value = "";
      $("#exampleModal").modal("hide");
    } else {
      toast.error("Elija una imagen");
    }

  };

  const callmodal = (show) => {
    const mod = new bots(document.getElementById("exampleModal"));
    show ? mod.show() : mod.hide();
  };


  const Validaciones = Yup.object().shape({
    incluye: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(1200, "No puede tener mas de 1200 caracteres"),
    dirigido: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(500, "No puede tener mas de 500 caracteres"),
    habilidadesCompartidas: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(1200, "No puede tener mas de 1200 caracteres"),
    requisitos: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(1200, "No puede tener mas de 1200 caracteres"),
  });

  return (
    <Fragment>
      <div className="content" style={{ width: "100%" }}>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-tab2"
          >
            <Formik
              enableReinitialize={true}
              initialValues={{
                companyId: course.companyProfileId?.companyProfileId ?? 0,
                contacto: course?.contacto ?? "",
                courseId: course?.companyCourseId ?? 0,
                descripcion: course?.descripcion ?? "",
                direccion: course?.direccion ?? "",
                dirigido: course?.dirigido ?? "",
                duracion: course?.duracion ?? "",
                fechaFin: course?.fechaFinal ?? "",
                fechaPublicacion: course?.fechaPublicacion ?? "",
                formacion: course?.formacion ?? "",
                formationCourseId: course.formationCourseId?.formationCourseId ?? "",
                habilidadesCompartidas: course?.habilidadesCompartidas ?? "",
                hora: course?.hora ?? "",
                idioma: course?.idioma ?? "",
                incluye: course?.incluye ?? "",
                inversion: course?.inversion ?? "",
                modalidadCourseId: course.modalidadCourseId?.modalidadCourseId ?? 0,
                nivelCourseId: course.nivelCourseId?.nivelCourseId ?? 0,
                nombre: course?.nombre ?? "",
                requisitos: course?.requisitos ?? "",
                sectorId: course.sectorId?.sectorId ?? 0,
                telefonoContacto: course?.telefonoContacto ?? "",
                tematica: course?.tematica ?? "",
                tipoFormacionId: course.tipoFormacionId?.tipoFormacionId ?? 0,
                url: course?.url ?? "",
                id: course.language?.id ?? 0,
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                setSubmitting(true);          
                

                if(course !== "") {
                  ActualizarCurso(values, resetForm, setSubmitting)
                }else {
                  postCurso(values, resetForm, setSubmitting);
                  setimgPortada(null);
                  setshowImgPortada(null);
                  setbanner(null);
                  setshowBanner(null);
                }

                
                
              }}
              validationSchema={Validaciones}
            >
              {({ errors, touched, isSubmitting }) => (
                <Form>
                  <div className="mb-3 row">
                    <div className="col-12 col-md-6">
                      <label htmlFor="cargo" className="form-label">
                        Información del Curso
                      </label>
                    </div>
                    <div className="col-12 col-md-6" id="select-info">
                      <label htmlFor="formationCourseId" className="form-label">
                        Seleccione el tipo de Formacion:
                      </label>
                      <Field
                        as="select"
                        className="form-select form-select-sm"
                        name="formationCourseId"
                      >
                        <option hidden>Seleccione un tipo</option>
                        {type_courses.map((item, index) => {
                          return (
                            <option key={index} value={item.formationCourseId}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                      {errors.formationCourseId &&
                        touched.formationCourseId && (
                          <span className="form__validation form__validation--error">
                            {errors.formationCourseId}
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <div className="profile__cover-photo ">
                      <img
                        id="portadaPic"
                        className="no-cover-image"
                        src={showImgPortada === "" ? imgPortada : showImgPortada}
                        style={{
                          maxHeight: "1380px",
                          maxWidth: "1300px",
                          width: "100%",
                          height: "100%",
                          borderRadius: "10px",
                        }}
                        alt="cover"
                      ></img>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#actualizar-portada-modal"
                        data-title="Portada"
                        className="btn btn--gradient"
                      >
                        Portada
                      </a>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <div className="profile__header-info">
                      <div className="profile__header-info-left">
                        <div className="row d-flex align-items-end">
                          <div className="col-12 col-md-3 d-flex justify-content-center">
                            <div className="profile__header-info-photo">
                              <a
                                href="#"
                                className="btn btn--white"
                                // data-bs-toggle="modal"
                                // data-bs-target="#exampleModal"
                                // data-title="Perfil"
                                onClick={() => callmodal(true)}
                              >
                                <img
                                  src={
                                    banner == ""
                                      ? ico_add_img
                                      : showBanner == ""
                                      ? banner
                                      : showBanner
                                  }
                                  alt="Añadir imagen"
                                  style={
                                    banner != "" || showBanner != ""
                                      ? {
                                          width: "145px",
                                          height: "136px",
                                          borderRadius: "9px",
                                          marginLeft: "-40px",
                                          marginTop: "-38px",
                                        }
                                      : {}
                                  }
                                ></img>
                              </a>
                            </div>
                          </div>
                          
                          <div className="col-12 col-md-9">
                            <div className="profile__header-info-description">
                              <div className="profile__header-info-description-name">
                                Ingresa Nombre del Curso / Beca / Capacitación
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label for="nombre" className="col-sm-2 col-form-label">
                          Nombre
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="nombre"
                            className="form-control"
                            id="inputNombre"
                          ></Field>
                          {errors.nombre && touched.nombre && (
                            <span className="form__validation form__validation--error">
                              {errors.nombre}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <label
                          for="tematica"
                          className="col-sm-2 col-form-label"
                        >
                          Temática
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="tematica"
                            className="form-control"
                            id="inputTematica"
                          ></Field>
                          {errors.tematica && touched.tematica && (
                            <span className="form__validation form__validation--error">
                              {errors.tematica}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="direccion"
                          className="col-sm-2 col-form-label"
                        >
                          Dirección
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="direccion"
                            className="form-control"
                            id="direccion"
                          ></Field>
                          {errors.direccion && touched.direccion && (
                            <span className="form__validation form__validation--error">
                              {errors.direccion}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <label
                          for="formacion"
                          className="col-sm-2 col-form-label"
                        >
                          Formación:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="formacion"
                            className="form-control"
                          ></Field>
                          {errors.formacion && touched.formacion && (
                            <span className="form__validation form__validation--error">
                              {errors.formacion}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="sectorId"
                          className="col-sm-2 col-form-label"
                        >
                          Sector:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            as="select"
                            name="sectorId"
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                          >
                            <option hidden selected>
                              Seleccione un sector
                            </option>
                            {sectorList.map((item, index) => {
                              return (
                                <option key={index} value={item.sectorId}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.sectorId && touched.sectorId && (
                            <span className="form__validation form__validation--error">
                              {errors.sectorId}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <label
                          for="nivelCourseId"
                          className="col-sm-2 col-form-label"
                        >
                          Nivel:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            as="select"
                            name="nivelCourseId"
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                          >
                            <option hidden selected>
                              Seleccione un Nivel
                            </option>
                            {levelCourses.map((item, index) => {
                              return (
                                <option key={index} value={item.nivelCourseId}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.nivelCourseId && touched.nivelCourseId && (
                            <span className="form__validation form__validation--error">
                              {errors.nivelCourseId}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="fechaPublicacion"
                          className="col-sm-4 col-form-label"
                        >
                          Fecha de Inicio:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="date"
                            name="fechaPublicacion"
                            className="form-control"
                            id="fechaPublicacion"
                          ></Field>
                          {errors.fechaPublicacion &&
                            touched.fechaPublicacion && (
                              <span className="form__validation form__validation--error">
                                {errors.fechaPublicacion}
                              </span>
                            )}
                        </div>
                      </div>
                      <div className="col">
                        <label
                          for="fechaFin"
                          className="col-sm-6 col-form-label"
                        >
                          Fecha Finalización:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="date"
                            name="fechaFin"
                            className="form-control"
                            id="fechaFin"
                          ></Field>
                          {errors.fechaFin && touched.fechaFin && (
                            <span className="form__validation form__validation--error">
                              {errors.fechaFin}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="modalidadCourseId"
                          className="col-sm-2 col-form-label"
                        >
                          Modalidad:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            as="select"
                            name="modalidadCourseId"
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                          >
                            <option hidden selected>
                              Seleccione una Modalidad
                            </option>
                            {modalidadCourses.map((item, index) => {
                              return (
                                <option
                                  key={index}
                                  value={item.modalidadCourseId}
                                >
                                  {item.name}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.modalidadCourseId &&
                            touched.modalidadCourseId && (
                              <span className="form__validation form__validation--error">
                                {errors.modalidadCourseId}
                              </span>
                            )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <label for="hora" className="col-sm-6 col-form-label">
                          Hora de inicio:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="hora"
                            className="form-control"
                            id="hora"
                          ></Field>
                          {errors.hora && touched.hora && (
                            <span className="form__validation form__validation--error">
                              {errors.hora}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label for="id" className="col-sm-2 col-form-label">
                          Lenguaje:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            as="select"
                            name="id"
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                          >
                            <option hidden selected>
                              Seleccione un lenguaje
                            </option>
                            {languagesList.map((item, index) => {
                              return (
                                <option key={index} value={item.id}>
                                  {item.description}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.id && touched.id && (
                            <span className="form__validation form__validation--error">
                              {errors.id}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <label
                          for="duracion"
                          className="col-sm-6 col-form-label"
                        >
                          Duración:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="duracion"
                            className="form-control"
                            id="duracion"
                          ></Field>
                          {errors.duracion && touched.duracion && (
                            <span className="form__validation form__validation--error">
                              {errors.duracion}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="contacto"
                          className="col-sm-6 col-form-label"
                        >
                          Nombre de Contacto:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="contacto"
                            className="form-control"
                          ></Field>
                          {errors.contacto && touched.contacto && (
                            <span className="form__validation form__validation--error">
                              {errors.contacto}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <label
                          for="telefonoContacto"
                          className="col-sm-6 col-form-label"
                        >
                          Número de Contacto:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="telefonoContacto"
                            className="form-control"
                          ></Field>
                          {errors.telefonoContacto &&
                            touched.telefonoContacto && (
                              <span className="form__validation form__validation--error">
                                {errors.telefonoContacto}
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="fechaPublicacion"
                          className="col-sm-4 col-form-label"
                        >
                          Url:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="url"
                            className="form-control"
                            id="url"
                          ></Field>
                          {errors.url && touched.url && (
                            <span className="form__validation form__validation--error">
                              {errors.url}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <label
                          for="inversion"
                          className="col-sm-2 col-form-label"
                        >
                          Inversión:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="inversion"
                            className="form-control"
                            required
                          ></Field>
                          {errors.inversion && touched.inversion && (
                            <span className="form__validation form__validation--error">
                              {errors.inversion}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-12 col-md-12">
                        <h6>Dirigido</h6>
                        <div className="m-st">
                          <Field
                            as="textarea"
                            name="dirigido"
                            id="dirigido"
                            className="form-control"
                            required
                          ></Field>
                          {errors.dirigido && touched.dirigido && (
                            <span className="form__validation form__validation--error">
                              {errors.dirigido}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-12 col-md-12">
                        <h6>Incluye</h6>
                        <div className="m-st">
                          <Field
                            as="textarea"
                            name="incluye"
                            id="incluye"
                            className="form-control"
                            required
                          ></Field>
                          {errors.incluye && touched.incluye && (
                            <span className="form__validation form__validation--error">
                              {errors.incluye}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-12 col-md-12">
                        <h6>Descripción</h6>
                        <div className="m-st">
                          <Field
                            as="textarea"
                            name="descripcion"
                            id="descripcion"
                            className="form-control"
                            required
                          ></Field>
                          {errors.descripcion && touched.descripcion && (
                            <span className="form__validation form__validation--error">
                              {errors.descripcion}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12 col-md-12">
                        <h6>Requisitos</h6>
                        <div className="m-st">
                          <Field
                            as="textarea"
                            name="requisitos"
                            id="requisitos"
                            className="form-control"
                            required
                          ></Field>
                          {errors.requisitos && touched.requisitos && (
                            <span className="form__validation form__validation--error">
                              {errors.requisitos}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-12 col-md-12">
                        <h6>Habilidades a Desarrollar</h6>
                        <div className="m-st">
                          <Field
                            as="textarea"
                            name="habilidadesCompartidas"
                            id="habilidadesCompartidas"
                            className="form-control"
                            required
                          ></Field>
                          {errors.habilidadesCompartidas &&
                            touched.habilidadesCompartidas && (
                              <span className="form__validation form__validation--error">
                                {errors.habilidadesCompartidas}
                              </span>
                            )}
                        </div>
                        <div className="form__row">
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn-info"
                          >
                            Guardar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      <div
        id="actualizar-portada-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form form--white ">
                <div className="div__wrapper">
                  <div className="form__description text-center">
                    Seleccione una imagen
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 col-md-8">
                      <label htmlFor="bannerImageUpdate">Banner</label>
                      <input
                        id="bannerImageUpdate"
                        type="file"
                        accept="image/*"
                        required
                      ></input>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      onClick={ActualizarPortada}
                      className="btn btn--gradient btn__icon btn__icon--door"
                      style={{ color: "white" }}
                    >
                      Actualizar Portada
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div
        class="modal fade kr-modal"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="form form--white ">
                <div className="div__wrapper">
                  <div className="form__description text-center">
                    Seleccione una imagen
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <label for="name">Imagen Perfil</label>
                    <div className="file">
                      <i className="fas fa-images"></i> Elegir archivo
                      <input
                        type="file"
                        id="profileImageUpdate"
                        accept="image/*"
                      />
                    </div>
                    <small className="green">Archivo Seleccionado</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                onClick={ActualizarPerfil}
                className="btn btn--gradient btn__icon btn__icon--door"
                style={{ color: "white" }}
              >
                Subir Perfil
              </button>
              {/* <button
                  data-bs-dismiss="modal"
                  style={{ display: "none" }}
                ></button> */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AddCurso;
